import { cn } from '../../../lib/utils'

export interface FleetSummaryItem {
  key: string
  label: string
  count: number
  /** Optional dot color class — `bg-st-run`, `bg-st-warn`, etc. */
  dotClass?: string
  /** Optional text color class for the count. */
  countClass?: string
}

/**
 * One-line fleet stats above the list grid. Renders as a compact pill
 * row of "● 12 active" / "● 2 paused" so an operator can read the page
 * state without scanning every card.
 */
export function FleetSummary({
  total,
  items,
  className
}: {
  total: number
  items: FleetSummaryItem[]
  className?: string
}) {
  return (
    <div
      className={cn('flex flex-wrap items-center gap-x-5 gap-y-1 text-sm text-ink-2', className)}
    >
      <span className="font-medium text-ink">
        {total} {total === 1 ? 'config' : 'configs'}
      </span>
      {items.map((item) => (
        <span key={item.key} className="inline-flex items-center gap-1.5">
          {item.dotClass && (
            <span className={cn('inline-block size-2 rounded-full', item.dotClass)} aria-hidden />
          )}
          <span className={cn('font-medium', item.countClass ?? 'text-ink')}>{item.count}</span>
          <span className="text-ink-3">{item.label}</span>
        </span>
      ))}
    </div>
  )
}
